import { render, staticRenderFns } from "./ContentViewSettingsImageCover.vue?vue&type=template&id=39abc401&scoped=true&"
import script from "./ContentViewSettingsImageCover.vue?vue&type=script&lang=js&"
export * from "./ContentViewSettingsImageCover.vue?vue&type=script&lang=js&"
import style0 from "./ContentViewSettingsImageCover.vue?vue&type=style&index=0&id=39abc401&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39abc401",
  null
  
)

export default component.exports